import React, { useEffect, useState } from 'react';
import { motion, PanInfo } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { carouselImages } from '../data/carouselImages';
function useVisibleCount() {
  const [visible, setVisible] = useState(1);
  useEffect(() => {
    const mq = window.matchMedia('(min-width: 768px)');
    const update = () => setVisible(mq.matches ? 3 : 1);
    update();
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, []);
  return visible;
}
export function ProductCarousel() {
  const visible = useVisibleCount();
  const maxIndex = Math.max(0, carouselImages.length - visible);
  const [index, setIndex] = useState(0);
  useEffect(() => {
    setIndex(i => Math.min(i, maxIndex));
  }, [maxIndex]);
  const prev = () => setIndex(i => i <= 0 ? maxIndex : i - 1);
  const next = () => setIndex(i => i >= maxIndex ? 0 : i + 1);
  const handlePanEnd = (_: unknown, info: PanInfo) => {
    if (info.offset.x < -40) next();else if (info.offset.x > 40) prev();
  };
  return <div className="relative w-full max-w-sm md:max-w-4xl mx-auto mb-6 sm:mb-8" role="region" aria-roledescription="carousel" aria-label="Inside the system — sample pages" data-id="element-224" data-mp="32bdyznuuberv">
      <div className="relative px-10 md:px-12" data-id="element-225" data-mp="2slm04hfpjzhl">
        <div className="overflow-hidden" style={{
        touchAction: 'pan-y'
      }} data-id="element-226" data-mp="2skt1y4uteib2">
          <motion.div className="flex cursor-grab active:cursor-grabbing select-none" animate={{
          x: `-${index * (100 / visible)}%`
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} onPanEnd={handlePanEnd} data-id="element-227" data-mp="2nnarga15fv0y">
            {carouselImages.map((img, i) => <div key={img.src} className="shrink-0 px-2" style={{
            width: `${100 / visible}%`
          }} aria-hidden={i < index || i >= index + visible} data-id="element-228" data-mp="29o1cfdooj6yk" data-mpi={i}>
                <div className="bg-cream-light border border-gold/60 rounded-xl p-2 shadow-[0_6px_20px_rgba(26,26,26,0.10)]" data-id="element-229" data-mp="7taisj6z0odj">
                  <img src={img.src} alt={img.alt} draggable={false} className="w-full h-auto rounded-lg pointer-events-none" data-id="element-230" data-mp="272k5v9icwesh" />
                </div>
              </div>)}
          </motion.div>
        </div>

        <button type="button" onClick={prev} aria-label="Previous image" className="absolute left-0 top-1/2 -translate-y-1/2 w-9 h-9 md:w-10 md:h-10 rounded-full bg-ink text-cream-light flex items-center justify-center shadow-md hover:bg-black transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-231" data-mp="2l1jq84yu67iu">
          <ChevronLeftIcon size={20} data-id="element-232" data-mp="zoqklnqy3v5z" />
        </button>
        <button type="button" onClick={next} aria-label="Next image" className="absolute right-0 top-1/2 -translate-y-1/2 w-9 h-9 md:w-10 md:h-10 rounded-full bg-ink text-cream-light flex items-center justify-center shadow-md hover:bg-black transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-233" data-mp="zn5o3sl2m25h">
          <ChevronRightIcon size={20} data-id="element-234" data-mp="3rupqavbf0tbs" />
        </button>
      </div>

      <div className="flex justify-center gap-2 mt-4" data-id="element-235" data-mp="3nup3ama939t4">
        {Array.from({
        length: maxIndex + 1
      }).map((_, i) => <button key={i} type="button" onClick={() => setIndex(i)} aria-label={`Go to slide ${i + 1}`} aria-current={i === index} className={`h-2 rounded-full transition-[width,background-color] duration-200 ${i === index ? 'w-6 bg-burgundy' : 'w-2 bg-ink/20 hover:bg-ink/40'}`} data-id="element-236" data-mp="305wd76gb7w6f" data-mpi={i} />)}
      </div>
    </div>;
}